import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// Detect Puppeteer or headless browser by user agent
const isPuppeteer = () => {
  if (navigator.userAgent.includes("NirantaraPuppeteerBot")) return true;
  if (navigator.userAgent.includes("HeadlessChrome")) return true;
  return false;
};

const useInactivityLogout = ({
  logoutTime = 60 * 60 * 1000,
  warningTime = 55 * 60 * 1000,
  onWarning,
  onLogout,
} = {}) => {
  const navigate = useNavigate();
  const logoutTimeoutRef = useRef(null);
  const warningTimeoutRef = useRef(null);

  const logout = () => {
    sessionStorage.clear();
    // localStorage.clear();
    if (onLogout) onLogout();
    else navigate("/login");
  };

  const resetTimers = () => {
    clearTimeout(warningTimeoutRef.current);
    clearTimeout(logoutTimeoutRef.current);

    if (onWarning) {
      warningTimeoutRef.current = setTimeout(onWarning, warningTime);
    }

    logoutTimeoutRef.current = setTimeout(logout, logoutTime);
  };

  useEffect(() => {
    // Skip inactivity logout for Puppeteer/headless browser
    if (isPuppeteer()) return;

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
    ];

    events.forEach((event) => window.addEventListener(event, resetTimers));

    resetTimers();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimers));
      clearTimeout(warningTimeoutRef.current);
      clearTimeout(logoutTimeoutRef.current);
    };
  }, []);
};

export default useInactivityLogout;
